import React, { useState } from 'react'
import ColorPickerInput from './ColorPickerInput';
import logo from "../../../assets/abbottLogo.png";
import frame from "../../../assets/frame.png";
import orevanLogo from "../../../assets/orevanEventsLogo.png";
import "./StepThreeStyle.css"

export const StepThree = ({ formData, updateFormData }) => {
  const [bgColor, setBgColor] = useState(formData?.bg_color)
  const [fontColor, setFontColor] = useState(formData?.font_color)
  const [btnColor, setBtnColor] = useState(formData?.btn_color)

  const handleBgColorChange = (color) => {
    setBgColor(color)
    updateFormData({
      ...formData,
      bg_color: color,
    })
  }

  const handleFontColorChange = (color) => {
    setFontColor(color)
    updateFormData({
      ...formData,
      font_color: color,
    })
  }
  
  const handleBtnColorChange = (color) => {
    setBtnColor(color)
    updateFormData({
      ...formData,
      btn_color: color,
    })
  }

  return (
    <div className="">
      <div className="grid grid-cols-3 gap-4 mt-8">
        <div>
          <label className="block text-black text-sm font-bold mb-2">Background Color</label>
          <ColorPickerInput  initialColor={bgColor} onChange={handleBgColorChange}/>
        </div>
        <div>
          <label className="block text-black text-sm font-bold mb-2">Font Color</label>
          <ColorPickerInput  initialColor={fontColor} onChange={handleFontColorChange}/>
        </div>
        <div>
          <label className="block text-black text-sm font-bold mb-2">Button Color</label>
          <ColorPickerInput initialColor={btnColor} onChange={handleBtnColorChange}/>
        </div>
      </div>

      <div className="flex justify-center mt-8">
        <div className="relative">
          <img src={frame} className="w-auto h-auto z-50 relative frame" />
          <div
            className="absolute inset-0 flex flex-col items-center justify-center space-y-4 p-4 rounded-[2.5em]"
            style={{ backgroundColor: bgColor }}
          >
            <div className="w-1/2 flex justify-center">
              <img
                className="w-44"
                src={logo}
                alt="abbottLogo"
                style={{ objectFit: "contain" }}
              />
            </div>
            {/* <p className="text-center w-full" style={{ color: fontColor }}>
              <b>Please Insert The Event ID</b>
            </p>
            <TextField
              className="w-80 rounded"
              disabled
              type="number"
              size="small"
              placeholder="Event ID"
              sx={{
                "& .MuiInputBase-input": {
                  color: fontColor,
                },
              }}
            />
            <button className="rounded px-4 py-2 text-white" style={{ backgroundColor: btnColor }}>
              Next
            </button> */}
            <div className="bg-white rounded rounded-3 d-flex flex-col align-items-center justify-content-center gap-2 w-4/6 px-4 py-4">
              <p className="m-0 text-center ">
                <b
                  className="text-center"
                  style={{ color: fontColor }}
                >
                  Welcome to <br /> {formData?.name}
                </b>
              </p>
              <button
                className="w-full rounded rounded-2 border-0 py-1 text-white mt-3"
                style={{ backgroundColor: btnColor }}
                disabled
              >
                Register
              </button>
            </div>
            <div className="w-100 flex justify-center">
              <img
                className="themeLogo lg:w-32 xl:w-36"
                src={orevanLogo}
                alt="themeLogo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}